const storageAvailable = (storage) => {
  try {
    const testKey = '__finbase_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (err) {
    return false;
  }
};

const memoryStore = {};
let resolvedStorage = undefined;

const getStorage = () => {
  if (resolvedStorage !== undefined) return resolvedStorage;
  if (storageAvailable(window.localStorage)) {
    resolvedStorage = window.localStorage;
    return resolvedStorage;
  }
  if (storageAvailable(window.sessionStorage)) {
    resolvedStorage = window.sessionStorage;
    return resolvedStorage;
  }
  resolvedStorage = null;
  return resolvedStorage;
};

export const getStoredItem = (key) => {
  const storage = getStorage();
  if (!storage) return Object.prototype.hasOwnProperty.call(memoryStore, key) ? memoryStore[key] : null;
  const value = storage.getItem(key);
  if (value !== null) return value;
  return Object.prototype.hasOwnProperty.call(memoryStore, key) ? memoryStore[key] : null;
};

export const setStoredItem = (key, value) => {
  const storage = getStorage();
  memoryStore[key] = value;
  if (!storage) return;
  storage.setItem(key, value);
};

export const removeStoredItem = (key) => {
  const storage = getStorage();
  delete memoryStore[key];
  if (!storage) return;
  storage.removeItem(key);
};
